import { useEffect } from "react";

type ShortcutHandler = () => void;

interface Shortcuts {
  onEnter?: ShortcutHandler;
  onNext?: ShortcutHandler;
  onEscape?: ShortcutHandler;
}

export function useKeyboardShortcuts({ onEnter, onNext, onEscape }: Shortcuts) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      // Don't trigger if typing in textarea or input
      const tag = (e.target as HTMLElement)?.tagName;
      if (tag === "TEXTAREA" || tag === "INPUT") return;

      // Don't trigger inside Monaco editor
      if ((e.target as HTMLElement)?.closest(".monaco-editor")) return;

      if (e.key === "Enter" && onEnter) {
        e.preventDefault();
        onEnter();
      }

      if (e.key === "ArrowRight" && onNext) {
        e.preventDefault();
        onNext();
      }

      if (e.key === "Escape" && onEscape) {
        e.preventDefault();
        onEscape();
      }
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onEnter, onNext, onEscape]);
}
